import { mobile, LOADING, NODATA } from "@/utils/constants";
const global = {
  state: {
    headerTitle: "تغذیه",
    showDetails: false,
    mobile: mobile.mobile,
    dialog: {
      show: false,
      icon: "check",
      message: "",
      key: -1,
      type: 0, // 0-normal //1- confirm
    },
    snackbar: {
      show: false,
      text: "",
      timeout: 3000,
    },
    progress: false,
    apiRunning: false,
    searchInput: "",
    tableText: LOADING,
    selectedMenu: 0,
    headerProps: {
      sortByText: "مرتب سازی بر اساس",
    },
    selectedFard: {
      fardId: 0,
    },
    pagination: {
      page: 1,
      pageSize: 10,
    },
  },

  mutations: {
    SET_HEADER_TITLE: (state, headerTitle) => {
      state.headerTitle = headerTitle;
    },
    SET_SHOW_DETAILS: (state, showDetails) => {
      state.showDetails = showDetails;
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile;
    },
    SET_DIALOG: (state, dialog) => {
      state.dialog = dialog;
    },
    SET_SNACKBAR_SHOW: (state, show) => {
      state.snackbar.show = show;
    },

    SET_PROGRESS_SHOW: (state, show) => {
      state.progress = show;
    },
    SET_API_RUNNING: (state, isRunning) => {
      state.apiRunning = isRunning;
    },
    SET_SNACKBAR_TEXT: (state, text) => {
      state.snackbar.text = text;
      state.snackbar.show = true;
    },
    SET_SNACKBAR_TIMEOUT: (state, timeout) => {
      state.snackbar.timeout = timeout;
    },
    SET_DIALOG_SHOW: (state, show) => {
      state.dialog.show = show;
    },
    SET_DIALOG_MESSAGE: (state, message) => {
      state.dialog.message = message;
    },
    SET_DIALOG_ICON: (state, icon) => {
      state.dialog.icon = icon;
    },
    SET_DIALOG_KEY: (state, key) => {
      state.dialog.key = key;
    },
    SET_DIALOG_TYPE: (state, type) => {
      state.dialog.type = type;
    },
    SET_SEARCH_INPUT: (state, searchInput) => {
      state.searchInput = searchInput;
    },
    SET_TABLE_TEXT: (state, isLoading) => {
      if (isLoading) {
        state.tableText = LOADING;
      } else {
        state.tableText = NODATA;
      }
    },
    SET_SELECTED_MENU: (state, menu) => {
      state.selectedMenu = menu;
    },
    SET_SELECTED_FARD: (state, fard) => {
      state.selectedFard = fard;
    },
    RESET_SELECTED_FARD: (state) => {
      state.selectedFard.fardId = 0;
    },
    SET_PAGINATION: (state, options) => {
      state.pagination = options;
    },
  },
};

export default global;
